import React from 'react';
import { WidgetDateTime, WidgetStatus, WidgetTruncatedText, WidgetLevelLinkText } from '../../../../components';
import { WidgetPrice } from '../../../../components/widget/WidgetPrice';
import statuses from '../../../../constants/paymentLinks/statuses';
import { useTranslation } from 'react-i18next';
import { palette } from '../../../../styles/theme';

export default function UsersWidgets () {
    const dniFormatter = Intl.NumberFormat('es-AR');
    const { t } = useTranslation();
    return [{
        dataField: 'id',
        text: t('paymentLinks.table.columns.linkNumber'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
    }, {
        dataField: 'full_name',
        text: t('paymentLinks.table.columns.client'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
    }, {
        dataField: 'document',
        text: t('paymentLinks.table.columns.dni'),
        sort: false,
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (cellContent, row) => (<WidgetLevelLinkText levelId={row.id_level} to={`/clients/details/${row.id_user}`} text={dniFormatter.format(cellContent) || ''} truncated ='false'/>),
        headerClasses: 'clientsColumnsMC_headers--title',
    }, {
        dataField: 'description',
        text: t('paymentLinks.table.columns.description'),
        sort: false,
        formatter: cellContent => (<WidgetTruncatedText text={cellContent || ''} styles={{ color: palette.primary.main, textDecoration: 'none' }}/>),
        headerClasses: 'clientsColumnsMC_headers--title',
    }, {
        dataField: 'amount',
        text: t('paymentLinks.table.columns.amount'),
        sort: false,
        formatter: cellContent => (<WidgetPrice number={cellContent} textAlign='left' width='80px' />),
        headerClasses: 'clientsColumnsMC_headers--title',
    }, {
        dataField: 'created_at',
        text: t('paymentLinks.table.columns.createdAt'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        formatter: cellContent => (< WidgetDateTime date={new Date(cellContent)} />),
    }, {
        dataField: 'updated_at',
        text: t('paymentLinks.table.columns.paymentDate'),
        headerClasses: 'clientsColumnsMC_headers--title',
        sort: false,
        formatter: cellContent => (cellContent ? (< WidgetDateTime date={new Date(cellContent)} />) : ''),
    }, {
        dataField: 'id_payment_link_status',
        text: t('paymentLinks.table.columns.status'),
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (cellContent, row) => {
            return (
                <WidgetStatus type={statuses[cellContent]?.type} text={`paymentLinks.table.filter.0.${cellContent - 1}`} />
            );
        },
        headerClasses: 'clientsColumnsMC_headers--title',
    }]
    ;
}
